// src/js/components/Evaluation/ModuleAnswer.js
import React, { Component } from "react";
import { connect } from "react-redux";
// import renderHTML from "react-render-html";
import {selectAnswerClick} from "../../actions";

const mapStateToProps = state => {
    return {
        modules: state.data.questionnaire.modules,
        results: state.results
    };
};

function mapDispatchToProps(dispatch) {
    return {
        selectAnswerClick: payload => dispatch(selectAnswerClick(payload))
    };
}

class ConnectedModuleAnswer extends Component {
    constructor(props){
        super(props);
        this.SwitchCheckbox = this.SwitchCheckbox.bind(this);
    }

    SwitchCheckbox(checked) {
        if(checked) {
            return (<span className="evCheckedBox">&#9635;</span>)
        } else {
            return (<span className="evUncheckedBox">&#9633;</span>)
        }
    }

    render() {
        const thismodule = this.props.modules[this.props.module];
        const thissubmodule = thismodule.submodules[this.props.submodule];

        let checked = false;
        if (this.props.results[this.props.module] !== undefined) {
            if (this.props.results[this.props.module][this.props.submodule] !== undefined) {
                if (this.props.results[this.props.module][this.props.submodule].answer === this.props.answer) {
                    checked = true;
                }
            }
        }

        return(
            <li className={`${checked}`} onClick={(e) => this.props.selectAnswerClick({ module: this.props.module, submodule: this.props.submodule, answer: this.props.answer, weight: thissubmodule.answers[this.props.answer].weight })}>
                { this.SwitchCheckbox(checked) }
                {thissubmodule.answers[this.props.answer].response}
            </li>
        )
    }
}
const ModuleAnswer = connect(mapStateToProps,mapDispatchToProps)(ConnectedModuleAnswer);

export default ModuleAnswer;